import { MeetingSessionStatusCode } from 'amazon-chime-sdk-js';

/** DeleteMeeting can surface through signaling or TURN, depending on connection timing. */
export function wasMeetingEndedByHost(code: MeetingSessionStatusCode): boolean {
  return (
    code === MeetingSessionStatusCode.MeetingEnded ||
    code === MeetingSessionStatusCode.TURNCredentialsForbidden
  );
}

export const JOINED_FROM_ANOTHER_DEVICE_TEXT = 'You joined from another device.';
export const CONNECTION_DROPPED_TEXT = 'Your connection to the session dropped. Join again to reconnect.';
export const REMOVED_FROM_SESSION_TEXT = 'You were removed from the session, or joined it from another window.';

/**
 * A call that ended in `error`: `elsewhere` when this same attendee is now live on another device
 * (AudioJoinedFromAnotherDevice), which must not be released, or that device would be dropped too.
 * AudioAttendeeRemoved (the attendee was deleted) is `removed` for a guest, whom only the provider removes. A client
 * is never removed by the provider: their attendee is deleted when another tab or device joins in their place, which
 * holds the client's spot now, so it is reported as `elsewhere`.
 */
export function droppedCallNotice(
  code: MeetingSessionStatusCode | undefined,
  role: 'client' | 'guest' = 'client',
): { message: string; elsewhere: boolean; removed: boolean } {
  const deleted = code === MeetingSessionStatusCode.AudioAttendeeRemoved;
  if (deleted && role === 'guest') return { message: REMOVED_FROM_SESSION_TEXT, elsewhere: false, removed: true };
  const elsewhere = deleted || code === MeetingSessionStatusCode.AudioJoinedFromAnotherDevice;
  return { message: elsewhere ? JOINED_FROM_ANOTHER_DEVICE_TEXT : CONNECTION_DROPPED_TEXT, elsewhere, removed: false };
}
